import React from 'react'
// import PropTypes from 'prop-types'

const arch = (Component, styles) => (props) => {
  return <Component {...props} style={styles} />
}

const BoxBase = arch('div', {
  padding: 0,
  margin: 0
})

export const Box = (props) => {
  const { children, title, type, root, onClick } = props
  return (
    <BoxBase
      title={title}
      type={type}
      root={root}
      // style={style}
      onClick={onClick}
      {...props}>
      {children}
    </BoxBase>
  )
}

Box.defaultProps = {
  onClick: () => {
    console.log('clicked')
  }
}

Box.displayName = 'b'
BoxBase.displayName = 'b'

export default Box
